import FieldDefs from './AdsFactsFieldDefs.js'
import {doLangFields} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.adsfacts", FieldDefs),
            sortOrder: [
                {
                    field: 'facts',
                    direction: 'desc'
                }
            ],
            moreParams: {}
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
